import { Ribbon } from '@tempmee/react';
import { BANNER_COPY } from '../constants';

export const InfoBanner = () => (
  <Ribbon variant="informational" data-testid="worker-type-info-banner">
    {BANNER_COPY}
  </Ribbon>
);
